export const locale = {
  lang: "it",
  data: {
    MENU: {
      MY_TASK_LIST: "I miei task",
      TODO: "Task",
      TASK_LIST: "Lista Task",
    },
    ALERT: {
      SUCCESS_TASK_SET_AS_TODO: "Task impostata correttamente in da fare.",
      SUCCESS_ADD_TASK: "Task creata correttamente",
      ERROR_ADD_TASK: "Errore nella creazione della task.",
      TASK_ADDED_BUT_SOME_ATTACHMENT_NOT: "La task è stata creata correttamente, tuttavia durante il caricamento degli allegati qualcuno di questi ha dato errore. Allega nuovamente quelli che mancano.",
      ERROR_ADD_TASK_MISSING_END_DATE: "Inserisci la data entro cui deve essere completata questa task.",
      ERROR_ADD_TASK_MISSING_TITLE: "Inserisci il titolo della task.",
      ERROR_ADD_TASK_MISSING_USER: "Inserisci almeno un destinatario per questa task.",
      CONFIRM_DELETE_ATTAHCMENT_TASK: "Confermi di voler rimuovere questo allegato?",
      SUCCESS_TASK_SET_AS_TAKEN: "Task impostata correttamente come in lavorazione.",
      ERROR_TASK_SET_STATUS: "Errore nel cambio di stato per la task selezionata.",
      SUCCESS_TASK_SET_AS_COMPLETED: "Task impostata correttamente come completata.",
      SUCCESS_TASK_COMMENT_ADDED: "Commento aggiunto correttamente",
      ERROR_UPDATING_TASK_DESCRIPTION: "Errore nella modifica della descrizione della task",
      ERROR_UPDATING_TASK_TITLE: "Errore nella modifica del titolo della task",
      ERROR_UPDATING_TASK_PRIORITY: "Errore nella modifica della priorità della task",
      CONFIRM_DELETE_TASK: "Sei sicuro di voler eliminare questa task",
      ERROR_TASK_ATTACHMENT_REMOVE: "Errore nella rimozione della task",
      SUCCESS_DELETE_TASK: "Task rimossa correttamente",
      ERROR_TASK_REMOVE: "Errore nella rimozione della task",
      CONFIRM_DELETE_TASK_COMMENT: "Sei sicuro di voler eliminare questo commento?",
      SUCCESS_DELETE_TASK_COMMENT: "Commento rimosso con successo",
      ERROR_TASK_COMMENT_REMOVE: "Errore nella rimozione del commento",
      SUCCESS_UPDATING_TASK: "Task aggiornata correttamente",
      ERROR_UPDATING_TASK: "Errore nella modifica del task",
    },
    TASK: "Task",
    HAS_CREATE_TASK: "ha creato il task",
    YOU_HAV_CREATED_THIS_TASK: "Hai creato questo task",
    YOU_HAVE_NO_TASK: "Non hai nessun task assegnato.",
    ADD_TASK: "Aggiungi task",
    SEARCH_TASK: "Cerca task",
    NO_TASKS: "Nessun task",
    TASK_ASSIGNED_TO_GROUP: "Task assegnata al gruppo",
    TASK_ASSIGNED_TO_ROLE: "Task assegnata al ruolo",
    NO_ATTACHMENTS_FOR_THIS_TASK: "Nessun allegato per questa task.",
    AND_TO: "ed a",
  },
};
